import { VideoCamera } from "@phosphor-icons/react"
import { Button } from "@/components/ui/button"
import { broadcastCallStatus } from "@/lib/call-status-broadcast"
import { useOpenNewWindow } from "@/modules/patients/detail/progress-note/hooks/useOpenNewWindow"
import { useMedicalRecordDialogStore } from "@/modules/patients/detail/store/useCloseMedicalRecordDialogStore"
import { useAppointmentParam } from "@/modules/patients/hooks/useAppointmentParam"
import { ContactChannel, Language } from "@/types/__generated__/union-types"

interface VideoCallButtonProps {
  progressNoteId: string
  language: Language
  contactChannel: ContactChannel
}

const VideoCallButton = ({ progressNoteId, language, contactChannel }: VideoCallButtonProps) => {
  const appointmentId = useAppointmentParam()
  const openNewWindow = useOpenNewWindow()
  const setShouldIncreaseMissedCall = useMedicalRecordDialogStore((state) => state.setShouldIncreaseMissedCall)

  const handleClick = () => {
    broadcastCallStatus({ channel: "video" })
    openNewWindow(
      `/video-call?appointmentId=${appointmentId}&progressNoteId=${progressNoteId}&language=${language}&contactChannel=${contactChannel}`,
      "sofia-video-call",
    )
    setShouldIncreaseMissedCall(true)
  }

  return (
    <Button
      variant="circle"
      className="bg-primary hover:bg-primary-hovered h-10 w-10 shrink-0 p-1"
      onClick={handleClick}
      data-testid="call-video-btn">
      <VideoCamera size={24} className="text-on-primary!" />
    </Button>
  )
}

export { VideoCallButton }
